<template>
  <Card class="mt-4 shadow-none">
    <template v-slot:subtitle>
      <p class="text-xl">Ingresa tu correo electrónico:</p>
    </template>
    <template v-slot:content>
      <div class="p-fluid">
        <div class="field">
          <InputText v-model="email" autocomplete="off" v-bind="emailAttrs" />
          <span class="error-message">
            {{ errors.email }}
          </span>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="grid grid-nogutter justify-content-between">
        <i></i>
        <Button
          class="text-sm font-light"
          label="Enviar código"
          @click="nextPage()"
          icon="pi pi-angle-right"
          iconPos="right"
        />
      </div>
    </template>
  </Card>
</template>
<script setup lang="ts">
  import { useField, useForm } from 'vee-validate'
  import { computed, ref, watch } from 'vue'
  import * as yup from 'yup'

  const emailSchema = yup
    .string()
    .trim()
    .email('Ingrese un correo válido')
    .required('El correo es requerido')

  const { values, errors, defineField, setFieldError } = useForm({
    validationSchema: yup.object({
      email: emailSchema,
    }),
  })

  const [email, emailAttrs] = defineField('email', {
    validateOnModelUpdate: false,
  })

  const emits = defineEmits(['next-page'])

  const nextPage = () => {
    // Validate the email field
    emailSchema
      .validate(email.value.trim())
      .then(() => {
        // If validation passes, proceed to emit the next-page event
        emits('next-page', {
          formData: { email: email.value.trim() },
          pageIndex: 0,
        })
      })
      .catch((err) => {
        // If validation fails, set the error message
        setFieldError('email', err.message)
        console.error('Validation error:', err.message)
        return
      })
  }
</script>
<style scoped>
  .error-message {
    padding-top: 5px;
    color: rgb(234, 68, 68);
    font-size: 12px;
  }
</style>
